import script from "./Password.vue?vue&type=script&lang=ts&setup=true"
export * from "./Password.vue?vue&type=script&lang=ts&setup=true"

import "./Password.vue?vue&type=style&index=0&id=5f041f1f&scoped=true&lang=css"

import exportComponent from "/builds/intranet/intranet/vue/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f041f1f"]])

export default __exports__